import {z} from 'zod';

export const SearchParams = z.object({
    page: z.number().default(1),
    pageSize: z.number().default(10),
    search: z.string().default(''),
});

export type SearchParams = z.infer<typeof SearchParams>;